import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const InfoErrorIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z"
                clipRule="evenodd"
            />
            <circle cx={12} cy={17} r={1} fill="currentColor" />
            <path
                stroke="currentColor"
                d="M11.11 2.735 2.747 19.044a1 1 0 0 0 .89 1.456h16.726a1 1 0 0 0 .89-1.456L12.89 2.735a1 1 0 0 0-1.78 0Z"
            />
        </svg>
    </IconWrapper>
)
